import _ from 'underscore';

import { ExplorableItemType } from '../models/ContentType';
import { ISharedVersionInfo } from '../models/ISharedVersionInfo';
import { ISharerInfo } from '../models/ISharedWithMeContentInfo';
import { IUserInfo } from '../models/IUserInfo';
import { ISharedVersion } from '../ServerApi/requests/GetShareActivityRequest';
import { IShareAction } from '../ServerApi/requests/GetSharedWithMeRequest';
import { MapperHelper } from './MapperHelper';

export module ShareActivityMapper {

  export function map(
    shareActions: IShareAction[],
    sharedVersions: _.Dictionary<_.Dictionary<ISharedVersion>>,
    sharers: _.Dictionary<IUserInfo>,
    deletedSharers: _.Dictionary<IUserInfo>,
  ): ISharedVersionInfo[] {

    return shareActions.map((shareAction: IShareAction): ISharedVersionInfo => {
      const currVersion = sharedVersions[shareAction.contentType][shareAction.contentId];
      const currSharer: ISharerInfo = shareAction.isSharerDeleted ?
        {
          ...deletedSharers[shareAction.sharerId],
          isDeleted: true
        } :
        {
          ...sharers[shareAction.sharerId],
          isDeleted: false
        };

      let contentType: ExplorableItemType;

      if (shareAction.contentType === 'customizedview') {
        contentType = 'customView';
      } else if (shareAction.contentType === 'view') {
        contentType = 'view';
      }

      return {
        id:                         currVersion && currVersion.id,
        contentType:                contentType,
        name:                       currVersion.name,
        message:                    shareAction.message,
        sharedAt:                   MapperHelper.toDate(shareAction.createdAt),
        sharer:                     currSharer,
        url:                        currVersion.url,
        isHidden:                   currVersion.isHidden,
      };
    });
  }
}
